import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    login
  } = useUser();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const success = await login(email, password);
      if (success) {
        navigate('/');
      } else {
        setError('Invalid email or password');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };
  return <div className="flex items-center justify-center min-h-screen bg-gray-100" data-id="element-281">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md" data-id="element-282">
        <div className="flex justify-center mb-6" data-id="element-283">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oCNg59UCgsypxdgQrDYR7c/pasted-image.png" alt="RowDate.com" className="h-20 w-auto" data-id="element-284" />
        </div>

        {error && <div className="border px-4 py-3 rounded mb-4" style={{
        backgroundColor: '#FEE2E2',
        borderColor: '#FE5757',
        color: '#991B1B'
      }} data-id="element-285">
            {error}
          </div>}
        <form onSubmit={handleSubmit} data-id="element-286">
          <div className="mb-4" data-id="element-287">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email" data-id="element-288">
              Email
            </label>
            <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Email" required disabled={loading} data-id="element-289" />
          </div>
          <div className="mb-6" data-id="element-290">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password" data-id="element-291">
              Password
            </label>
            <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Password" required disabled={loading} data-id="element-292" />
          </div>
          <div className="flex items-center justify-between" data-id="element-293">
            <button type="submit" disabled={loading} className="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full disabled:opacity-50 disabled:cursor-not-allowed" style={{
            backgroundColor: '#4772B0'
          }} onMouseEnter={e => !loading && (e.currentTarget.style.backgroundColor = '#EF5350')} onMouseLeave={e => !loading && (e.currentTarget.style.backgroundColor = '#4772B0')} data-id="element-294">
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default Login;